import { Pipe, PipeTransform } from '@angular/core';

import { Learning_Type } from '@app/enums/learning-type.enum';
import { User } from '@app/models/user.model';
import { environment } from '@environments/environment';
import { isValidSubscription } from '@app/utilities/_index';

@Pipe({
  name: 'sessionEnrollmentRoute',
  pure: false,
  standalone: false,
})
export class SessionEnrollmentRoutePipe implements PipeTransform {
  /**
   * Session Enrollment Route Pipe.
   * @param learningType - learning type to transform to new display type
   * @param user - If user is signed in, then the transformed type will return a different display type.
   * @param subscriptionId - Subscription id used to check if the user has this subscription
   * @param courseId - Course id used to check if the use has this enrollment already to determine enrollment status
   * @param slugName - Get the SlugName of a course
   * @param subscriptionSlugName - Subscription slug name used to redirect to subscription detail page.
   * @param courseType - Get the course Type.
   * @param sessionId - Session id used to chck if the user has the enrolled session in enrollments.
   * @param countEnroll - Current number of users enrolled in a session.
   * @param maxEnroll - Maximum number of users that can be enrolled in a session.
   * @returns - transformed call to action string
   */
  transform(
    learningType: string,
    user: User,
    subscriptionId: number,
    relatedSubscriptionIds: number[],
    courseId: number,
    slugName: string,
    subscriptionSlugName: string,
    courseType: string,
    sessionId: number,
    countEnroll?: number,
    maxEnroll?: number
  ): string {
    switch (learningType) {
      case Learning_Type.INSTRUCTOR_LED:
      case Learning_Type.INSTRUCTOR_LED_IN_PERSON:
      case Learning_Type.INSTRUCTOR_LED_VIRTUAL:
      case Learning_Type.IN_PERSON:
      case Learning_Type.VIRTUAL:
      case Learning_Type.WORKSHOP:
        if (
          user &&
          subscriptionSlugName &&
          slugName &&
          subscriptionSlugName &&
          courseType &&
          sessionId
        ) {
          if (user && user.activeSubscriptions && user.activeSubscriptions.length > 0) {
            // Check if user has active subscription id that matches incoming subscription id
            const isSubscribed = isValidSubscription(relatedSubscriptionIds, subscriptionId, user);
            if (isSubscribed) {
              // NOTE: Check if the user enrollment message to update this if they are already in enrolled.
              const enrollment =
                user.enrollments &&
                user.enrollments.length > 0 &&
                user.enrollments.find((courseEnrollment) => courseEnrollment.id === courseId);
              if (enrollment) {
                // Check enrollment sessions and check if the incoming session id
                const enrolledSession =
                  enrollment.enrolledSessions &&
                  enrollment.enrolledSessions.length > 0 &&
                  enrollment.enrolledSessions.find((session) => session.id === sessionId);
                if (enrolledSession) {
                  // If user has enrolled session and is enrolled, redirect user as external url
                  return `${environment.docebo.url}/learn/course/internal/view/${courseType}/${courseId}/${slugName}`;
                } else {
                  return `subscription/${subscriptionSlugName}`;
                }
              } else {
                // Check if the Seats are left for the session to Enroll.
                if (maxEnroll > countEnroll) {
                  return `${environment.docebo.url}/learn/course/internal/view/${courseType}/${courseId}/${slugName}`;
                } else {
                  return `subscription/${subscriptionSlugName}`;
                }
              }
            } else {
              // User is not subscribed to this subscription id
              return `subscription/${subscriptionSlugName}`;
            }
          } else {
            // User is not subscribed to this subscription id
            return `subscription/${subscriptionSlugName}`;
          }
        } else {
          return `login`;
        }
    }
  }
}
